export const OPTHINES = {
  voteName: '2020project/2020grandceremony',
  mustSearch: 'Button',
  buttonBg: '#f4a842',
  tickets: true,
  hasVoteButton: {
    text: '点赞',
    themeColor: '#990708',
    textColor: '#fff',
  },
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  checkBox: true,
  themeColor: {
    activeBgColor: '#df0000',
    inactiveBgColor: '#f1f1f1',
  },
  tabs: [
    {
      tabName: '首页',
      tabPath: '/20200108GJKYSD/first',
    },
    {
      tabName: '活动规则',
      tabPath: '/20200108GJKYSD/second',
    },
  ],
};
